import React from "react";
import { connect } from 'react-redux'


import { Card, Col } from "reactstrap";
import CardBody from "reactstrap/lib/CardBody";
import { StandardList } from './StandardList';


var setupService = require ('../api');


class LastCommits extends React.Component {

    componentDidMount() {
        setupService.getCommits(  )
        .then( json => {
            this.setState( { lastCommits: json } );
        } )
    }
  
    constructor(props) {
      super(props);
      this.state = {
        lastCommits : []
      }
  
   }



render() {
    let actions = [ 
        // { label: "Validar", act: this.validate, type:'success' },
        // { label: "Volver Anterior", act: this.rollback, type:'warning' } ,
        // { label: "Blanquear", act: this.clean, type:'danger' }  
    ]
    let commits = [];
    if (!this.state.lastCommits.error) {
         commits = this.state.lastCommits.map( (com) => {
            return (
                { 'message': com.commit.message,
                'commit_date': com.commit.committer.date  }
            )
        });
    } else {
        commits = [{commit_date: new Date(), message: 'ATENCION: No pude obtener las ultimas actualizaciones'}];
    }
    // Filtro loes merges
    commits = commits.filter( (com) => !com.message.startsWith("Merge branch") );


    let cols = [
        { id: 'commit_date', title: 'Fecha', type:"DATETIME"}, 
        { id: 'message', title: 'Comentarios', type:"STRING", align:"left"}
       ] ;

    return (
        <>
        <Col > 
            <Card>
                <CardBody>

                <StandardList
                    title="Ultimas Modificaciones"
                    rows={commits}
                    cols={cols}
                    actions={actions}
                    />
                </CardBody>

            </Card>
        </Col>
        </>
    )
    }
}


const mapStateToProps = state => {
    return {
        view: state.view,
        school: state.config.school,
        token: state.auth.session.jwt_token,
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 

    //   getUserDashboard: ( token ) => {
    //     dispatch( setupActions.getUserDashboard( token )) ;
    //   }
        

 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(LastCommits);

